export default "__VITE_ASSET__CT2d0sKY__"